import { render, staticRenderFns } from "./xixun.vue?vue&type=template&id=d5e918b6&scoped=true"
import script from "./xixun.vue?vue&type=script&lang=js"
export * from "./xixun.vue?vue&type=script&lang=js"
import style0 from "./xixun.vue?vue&type=style&index=0&id=d5e918b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e918b6",
  null
  
)

export default component.exports